import type from "./types";

export function saveTemplate(data: any) {
  return {
    type: type.SELECTED_TEMPLATE,
    data: data
  };
}

export function timeLineTemplate(data: any) {
  return {
    type: type.SELECTED_TIMELINE_TEMPLATE,
    data: data
  };
}

export function setCondBackground(data:any) {
  return {
    type : type.CONDITION_COLORS_BACKGROUND,
    data : data
  }
}
export function setCondColor(data:any) {
  return {
    type : type.CONDITION_COLORS_FONTCOLOR,
    data : data
  }
}
export function setTitleFontColor(data: any) {
  return {
    type: type.TITLE_FONT_COLOR,
    data: data
  }
}
export function setSubTitleFontColor(data: any) {
  return {
    type: type.SUBTITLE_FONT_COLOR,
     data: data
  }
}
export function setBadgeFontColor(data: any) {
  return {
    type: type.TITLE_FONT_COLOR,
    data: data
  }
}